import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const whiteColor = '#FFFFFF';
const primaryPinkColor = '#D4106E';
const brandBlackColor = '#333333';
const grey500Color = '#979797';
const grey300Color = '#BFBFBF';

const adosaLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#D50000',
    info: '#2196F3',
    primary: primaryPinkColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB8C00',
    background: whiteColor,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: brandBlackColor,
    systemToolbar: brandBlackColor,
    navigationDrawer: primaryPinkColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': '#4A4A4A',
    'on-systemToolbar': whiteColor,
  },
};

export const adosaTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: adosaLightTheme,
  },
};
